﻿<template>

    <header class="header">
        <header_menu></header_menu>
        <hero v-if="isValidView() && is_fully_paid()" :title="getConfirmationText()" :subtitle="getSubtitle()" :hero_image="getHeroImage()"></hero>
        <hero v-else-if="!isValidView()" title="404 (page not found)" subtitle="Whoops! You've hit a 404 (page not found). Sorry, you'll have to turn around." :hero_image="getHeroImage()"></hero>
        <div v-if="!isValidView()" class="flex flex-col items-center"><button type="button" class="m-10 px-10 py-2 button button-pink-book" @click="home_Click()">Return to Home Page</button></div>
    </header>

    <main class="main" v-if="isValidView()">

        <!-- Confirmation email notice -->
        <div v-if="(!isAgent_Login() && GetBrand() == 'HEX') && is_fully_paid()" class="cart-addon m-10">
            <p class="m-auto font-bold text-black pt-2 text-center">If you don't receive a confirmation email please contact us at <a href="mailto:info@highlandexplorertours.com">info@highlandexplorertours.com</a></p>
        </div>
        <div v-if="(!isAgent_Login() && GetBrand() == 'HAG') && is_fully_paid()" class="cart-addon m-10">
            <p class="m-auto font-bold text-black pt-2 text-center">If you don't receive a confirmation email please contact us at <a href="mailto:info@haggisadventures.com">info@haggisadventures.com</a></p>
        </div>

        <!-- Payment failure / part payment block -->
        <div v-if="!isAgent_Login() && !is_fully_paid()" class="max-w-lg mx-auto px-6 py-10 flex flex-col items-center text-center gap-6">

            <div class="w-16 h-10 rounded-full flex items-center justify-center" :class="is_part_paid() ">
                <svg v-if="is_part_paid()" xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M12 3a9 9 0 100 18A9 9 0 0012 3z" />
                </svg>
            </div>

            <div>
                <h2 class="text-heading font-bold text-2xl mb-2">
                    {{ is_part_paid() ? 'Deposit received' : 'Payment unsuccessful' }}
                </h2>
                <p class="text-grey-dark text-sm leading-relaxed">
                    <template v-if="is_part_paid()">
                        A partial payment was received but your booking is not yet fully paid. Your booking reference is <strong>#{{ $store.getters.get_Booking?.group_booking_id }}</strong> - to pay the remaining balance use the button below.
                    </template>
                    <template v-else>
                        Your payment was unsuccessful or cancelled. You have not been charged. Your booking reference is <strong>#{{ $store.getters.get_Booking?.group_booking_id }}</strong> - please quote this if you contact us.
                    </template>
                </p>
            </div>

            <div class="w-full bg-grey-lightest rounded-xl px-6 py-5 flex flex-col gap-3 text-left text-sm">
                <p class="text-grey-dark">
                    <template v-if="is_part_paid()">To pay your remaining balance please use the button below, or contact us if you have any questions:</template>
                    <template v-else>To complete your booking please try again, or contact us:</template>
                </p>
                <a v-if="GetBrand() == 'HEX'" href="mailto:info@highlandexplorertours.com" class="text-action font-semibold">info@highlandexplorertours.com</a>
                <a v-else-if="GetBrand() == 'HAG'" href="mailto:info@haggisadventures.com" class="text-action font-semibold">info@haggisadventures.com</a>
            </div>

            <button v-if="is_part_paid()" type="button" class="button button-pink-book w-full" @click="redirect_to_paymentpage()">
                Pay remaining balance
            </button> 
            <button v-else type="button" class="button button-pink-book w-full" @click="home_Click()">
                Try again
            </button>
            <a href="/" class="w-full text-center py-2 text-sm font-semibold text-grey-dark hover:text-heading transition-colors">
                Back to homepage
            </a>

        </div>

        <div class="row mt-12" id="PaymentConfirmed">
            <h2 v-if="is_fully_paid()">Booked itinerary</h2>
            <h2 v-else-if="is_part_paid()">Partially paid itinerary</h2>
            <h2 v-else>Attempted booking itinerary</h2>
        </div>

        <div class="row">
            <div class="payment cart-content flex flex-col md:flex-row">
                <div class="cart-items w-full md:w-7/12 lg:w-8/12 pr-0 md:pr-4 xl:pr-8 mb-8">
                    <basket></basket>
                    <documentation :class="{'hidden': isAgent_Login() == false}"></documentation>
                    <trip_summary class="block md:hidden mb-4"></trip_summary>
                    <iframe v-if="!isAgent_Login()" :src="getFloDeskURL()" class="align-left w-full h-screen overflow-hidden" title="flodesk Iframe"></iframe>
                </div>
                <trip_summary class="hidden md:block"></trip_summary>
            </div>
        </div>

    </main>

    <footer_item></footer_item>

</template>

<script lang="ts" src="./5_confirmation.ts"></script>